import { createRoot } from "react-dom/client";
import { CaseSuccess } from "../../athena/CaseSuccess";

export function initAthenaCaseSuccess() {
  const container = document.getElementById("athena-case-success");

  if (container) {
    const root = createRoot(container);

    const { publicId, caseType } = container.dataset;

    root.render(<CaseSuccess publicId={publicId} caseType={caseType} />);
  }
}
